import { Injectable } from '@angular/core';
import { environment } from '@deltager/organizers/admin/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  BatchUpdateSession,
  NesSession,
  NesSessionsInfo,
  SessionName,
} from '@deltager/organizers/admin/modules/event-sessions/event-session-calendar/session.model';
import { PriceSessionSetup } from '@deltager/organizers/admin/modules/event-sessions/components/price-assign-session-popup/price-assign-helper';

@Injectable({
  providedIn: 'root',
})
export class NesSessionService {
  constructor(private http: HttpClient) {}

  public getEventSessionsList(eventId: number, from: string, to: string): Observable<NesSessionsInfo> {
    // 2024-04-01
    return this.http.get<NesSessionsInfo>(
      `${environment.apiBaseURL}/eventsessions/${eventId}/sessionsetups?startDate=${from}&endDate=${to}`,
    );
  }

  public getSessionNames(eventId: number): Observable<SessionName[]> {
    return this.http.get<SessionName[]>(`${environment.apiBaseURL}/eventsessions/${eventId}/sessionnames`);
  }

  public getSession(s: NesSession, eventId: number): Observable<NesSession> {
    return this.http.get<NesSession>(
      `${environment.apiBaseURL}/eventsessions/${eventId}/sessionsetups/${s.sessionSetupId}?date=${s.date}`,
    );
  }

  public deleteSession(s: NesSession, eventId: number): Observable<boolean> {
    return this.http.delete<boolean>(
      `${environment.apiBaseURL}/eventsessions/${eventId}/sessionsetups/${s.sessionSetupId}?date=${s.date}`,
    );
  }

  public addSession(s: NesSession, eventId: number): Observable<boolean> {
    return this.http.post<boolean>(`${environment.apiBaseURL}/eventsessions/${eventId}`, s);
  }

  public patchSession(s: NesSession, eventId: number): Observable<NesSession> {
    return this.http.patch<NesSession>(
      `${environment.apiBaseURL}/eventsessions/${eventId}/sessionsetups/${s.sessionSetupId}`,
      s,
    );
  }

  public batchUpdateSession(s: BatchUpdateSession): Observable<boolean> {
    return this.http.patch<boolean>(`${environment.apiBaseURL}/eventsessions/${s.eventId}/batchupdate`, s);
  }

  public batchDeleteSession(s: string[], eventId: number): Observable<boolean> {
    return this.http.delete<boolean>(`${environment.apiBaseURL}/eventsessions/${eventId}/batchdelete`, {
      body: {
        sessionNames: s,
        eventId: eventId,
      },
    });
  }

  public getPriceSessionSetup(priceId: number, eventId: number): Observable<PriceSessionSetup> {
    return this.http.get<PriceSessionSetup>(`${environment.apiBaseURL}/eventsessions/${eventId}/prices/${priceId}`);
  }

  public setPriceSessionSetup(priceId: number, eventId: number, ps: PriceSessionSetup): Observable<boolean> {
    return this.http.patch<boolean>(`${environment.apiBaseURL}/eventsessions/${eventId}/prices/${priceId}`, ps);
  }
}
